import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Flex, Icon, Label, mediaQueries } from '@zeal/web-ui';
import { useMediaQuery } from '@zeal/zeal-lib';

const TokenErrorCard = () => {
	const { t } = useTranslation('forgotPassword');
	const isDesktop = useMediaQuery(mediaQueries.min.md);

	const navigate = useNavigate();

	return (
		<Flex isColumn gap="6" align="center" className="h-full">
			<Flex
				gap="4"
				isColumn
				justify={isDesktop ? 'center' : 'start'}
				align="center"
				className="h-full px-4 pt-12 pb-8 md:py-12 md:px-7"
				style={{
					width: isDesktop ? '560px' : '343px',
				}}
			>
				<Icon
					iconName="circleExclamation"
					variant="regular"
					colorVariant="warning"
					size="3x"
				/>
				<Label.Big600 className="mt-2">{t('link_invalid')}</Label.Big600>
				<Label.Thin300 variant="subdued" textAlign="center">
					{t('link_invalid_description')}
				</Label.Thin300>

				<Button
					variant="primary"
					size="lg"
					className={`w-full ${isDesktop ? 'mt-8' : 'mt-4'} `}
					onClick={() => navigate('/login')}
				>
					{t('back_to_login')}
				</Button>
				<Label.Big300>
					{t('Need help?')}
					<Label.Thin300>{t(' email us at')}</Label.Thin300> &nbsp;
					<a href="mailto:support@getzeal.io">
						<Label.Mid300
							variant="interactive"
							className="hover:text-text-interactive"
						>
							support@getzeal.io
						</Label.Mid300>
					</a>
				</Label.Big300>
			</Flex>
		</Flex>
	);
};

export default TokenErrorCard;
